import { createSelector } from "@reduxjs/toolkit";
import { ChfarShopParamsSliceState } from "./slice";

export type ChfarShopParamsState = {
  changeForAnyReason: {
    shopParams: ChfarShopParamsSliceState;
  };
};

export const selectChfarShopParams = (state: ChfarShopParamsState) =>
  state.changeForAnyReason.shopParams.values;

export const selectValidChfarShopQueryParams = createSelector(
  [selectChfarShopParams],
  (params) =>
    Object.keys(params).reduce((acc, key) => {
      if (params[key as keyof ChfarShopParamsSliceState["values"]] != null) {
        acc[key] = params[key as keyof ChfarShopParamsSliceState["values"]];
      }
      return acc;
    }, {} as Partial<ChfarShopParamsSliceState["values"]>)
);
